import { action, computed, makeObservable, observable } from 'mobx';
import toast from 'react-hot-toast';
import {
  fixTimezoneOffset,
  fixTimezoneOffsetYYYYMMDD,
} from '../../constants/constants';
import URLConstants from '../../constants/url-constants';
import config from '../../helpers/config-helper';
import { IAddTray, IUpdateTray } from '../../models/forms/IAddUpdateTray';
import { IMultiSelectOption } from '../../models/ICommon';
import { ISaveProcessOrder } from '../../models/ISaveProcessOrder';
import {
  IActiveProcesses,
  IActiveTrayListVM,
  IActiveTrayProcessDue,
  IActiveTrayVM,
} from '../../models/response/IActiveTrayResponse';
import IApiResponse, {
  IApiSuccessResponse,
} from '../../models/response/IApiResponse';
import { ITrayVM } from '../../models/response/ITrayResponse';
import { IActiveTrayManagementState } from '../../models/state/IActiveTrayManagementState';
import { formatMessage } from '../../translations/format-message';
import {
  GetAllActiveTrayState,
  GetTrayState,
  ObservableInitialState,
} from '../initialState';
import * as baseService from '../service/base-service';
import { getTenantIdFromLocalStorage } from '../../helpers/localstorage-helper';
import { IActiveTrayFilter } from '../../models/IActiveTrayFilter';
const appConfig = config();

export class ActiveTrayManagementStore implements IActiveTrayManagementState {
  initialStateValue = ObservableInitialState;
  activeTrayList: IActiveTrayListVM = GetAllActiveTrayState;
  activeTray: IActiveTrayVM | undefined = undefined;
  activeTrayState = { ...this.initialStateValue };
  addUpdateTrayState = { ...this.initialStateValue };
  deleteTrayState = { ...this.initialStateValue };
  getActiveTrayListServiceState = { ...this.initialStateValue };
  fileUploadState = { ...this.initialStateValue };
  getProcessWiseChartListServiceState = { ...this.initialStateValue };
  getUpdateProcessDueDatetState = {
    ...this.initialStateValue,
  };
  duplicateData: string = null;
  processWiseChartList: any[] = [];
  saveProcessOrderState = { ...this.initialStateValue };
  updateProcessDueDateWithFilterState = {...this.initialStateValue};
  recordsUpdated: number = 0;

  constructor() {
    makeObservable(this, {
      activeTray: observable,
      activeTrayState: observable,
      activeTrayList: observable,
      addUpdateTrayState: observable,
      deleteTrayState: observable,
      getActiveTrayListServiceState: observable,
      GetActiveTrayListService: action,
      // GetTrayByIdService: action,
      AddTrayService: action,
      UpdateTrayService: action,
      DeleteTrayService: action,
      resetDeleteTray: action,
      resetAddUpdateTrayState: action,
      reset: action,
      allActiveTrays: computed,
      trayDetails: computed,
      trayFileUploadService: action,
      fileUploadState: observable,
      resetFileUploadState: action,
      allProcessHeaders: computed,
      getProcessWiseChartListServiceState: observable,
      processWiseChartList: observable,
      GetProcessWiseChartListService: action,
      chartHeaders: computed,
      chartData: computed,
      UpdateProcessDueDatetService: action,
      getUpdateProcessDueDatetState: observable,
      resetGetUpdateProcessDueDatetState: action,
      allProcessHeadersSequence: computed,
      SaveProcessOrderService: action,
      saveProcessOrderState: observable,
      resetSaveProcessOrderState: action,
      UpdateProcessDueDateWithFilterService: action,
      updateProcessDueDateWithFilterState: observable,
      resetUpdateProcessDueDateWithFilterState: action,
      recordsUpdated: observable,
      resetStore: action,
    });
  }

  //#region Actions
  GetActiveTrayListService = (
    TenantId: number,
    PageSize: number,
    PageNo: number,
    filters: string,
    // ProcessOrder: string
  ) => {
    this.getActiveTrayListServiceState.inProgress = true;
    // const processOrder = ProcessOrder === 'null' ? '' : ProcessOrder;
    const url = `${URLConstants.GetAllActiveTraysList}?TenantId=${TenantId}&PageSize=${PageSize}&PageNo=${PageNo}&filters=${filters}`;
    return baseService
      .getRequest(url)
      .then(
        (response: IApiResponse<IApiSuccessResponse<IActiveTrayListVM>>) => {
          if (response.data.Error) {
            this.getActiveTrayListServiceState.error = response.data.Message;
            toast.error(formatMessage(response.data.Message));
          } else {
            this.activeTrayList = response.data.Data;
            this.getActiveTrayListServiceState.success = true;
          }
        }
      )
      .catch((err: string) => {
        this.getActiveTrayListServiceState.error = err;
      })
      .finally(
        action(() => {
          this.getActiveTrayListServiceState.inProgress = false;
        })
      );
  };

  AddTrayService = (data: IAddTray) => {
    this.addUpdateTrayState.inProgress = true;
    const url = URLConstants.AddTray;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateTrayState.error = response.data.Message;
        } else {
          this.addUpdateTrayState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateTrayState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateTrayState.inProgress = false;
        })
      );
  };

  UpdateTrayService = (data: IUpdateTray) => {
    this.addUpdateTrayState.inProgress = true;
    let url = URLConstants.UpdateTray;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateTrayState.error = response.data.Message;
        } else {
          this.addUpdateTrayState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateTrayState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateTrayState.inProgress = false;
        })
      );
  };

  DeleteTrayService = (TenantId: number, TrayId: number) => {
    this.deleteTrayState.inProgress = true;
    let url = `${URLConstants.DeleteTray}?TenantId=${TenantId}&TrayId=${TrayId}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteTrayState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteTrayState.success = true;
      })
      .catch((err: string) => {
        this.deleteTrayState.error = err;
      })
      .finally(
        action(() => {
          this.deleteTrayState.inProgress = false;
        })
      );
  };

  trayFileUploadService = (TenantId: number, csvFile: File) => {
    this.fileUploadState.inProgress = true;
    const url = `${URLConstants.UploadTrayFile}?TenantId=${TenantId}`;
    const formData = new FormData();
    formData.append('csvFile', csvFile);
    return baseService
      .postMultipart(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.fileUploadState.error = response.data.Message;
        } else {
          if (response.data.Data) {
            this.duplicateData = response.data.Data;
          }
          this.fileUploadState.success = true;
        }
      })
      .catch((err: string) => {
        this.fileUploadState.error = formatMessage('SomethingWentWrong');
        console.error(err);
      })
      .finally(
        action(() => {
          this.fileUploadState.inProgress = false;
        })
      );
  };

  GetProcessWiseChartListService = (TenantId: number, timeZone: number, subContractor: number) => {
    this.getProcessWiseChartListServiceState.inProgress = true;
    const url = `${URLConstants.GetProcessWiseChart}?TenantId=${TenantId}&timeZone=${timeZone}&SubContractor=${subContractor}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getProcessWiseChartListServiceState.error =
            response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.processWiseChartList = response.data.Data;
          this.getProcessWiseChartListServiceState.success = true;
        }
      })
      .catch((err: string) => {
        this.getProcessWiseChartListServiceState.error = err;
      })
      .finally(
        action(() => {
          this.getProcessWiseChartListServiceState.inProgress = false;
        })
      );
  };

  UpdateProcessDueDatetService = (
    selectedCheckedTrayId: string,
    TenantId: number,
    orderProcessId: number,
    dueDate: string
  ) => {
    this.getUpdateProcessDueDatetState.inProgress = true;
    const url = `${URLConstants.UpdateProcessDueDate}?TenantId=${TenantId}&orderProcessId=${orderProcessId}&dueDate=${dueDate}&TrayId=${selectedCheckedTrayId}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.getUpdateProcessDueDatetState.error = response.data.Message;
        } else {
          this.getUpdateProcessDueDatetState.success = true;
        }
      })
      .catch((err: string) => {
        this.getUpdateProcessDueDatetState.error = err;
      })
      .finally(
        action(() => {
          this.getUpdateProcessDueDatetState.inProgress = false;
        })
      );
  };

  SaveProcessOrderService = (data: ISaveProcessOrder) => {
    this.saveProcessOrderState.inProgress = true;
    const url = URLConstants.SaveProcessOrder;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.saveProcessOrderState.error = response.data.Message;
        } else {
          this.saveProcessOrderState.success = true;
        }
      })
      .catch((err: string) => {
        this.saveProcessOrderState.error = err;
      })
      .finally(
        action(() => {
          this.saveProcessOrderState.inProgress = false;
        })
      );
  };

  UpdateProcessDueDateWithFilterService = (
    orderProcessId: number,
    dueDate: string,
    filter: IActiveTrayFilter
  ) => {
    this.updateProcessDueDateWithFilterState.inProgress = true;
    const url = `${URLConstants.UpdateProcessDueDateWithFilter}`;
    const data = {
      TenantId: Number(getTenantIdFromLocalStorage()),
      DueDate: dueDate,
      OrderProcessID: orderProcessId,
      filters: filter
    }
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<any>>) => {
        if (response.data.Error) {
          this.updateProcessDueDateWithFilterState.error = response.data.Message;
        } else {
          this.recordsUpdated = response.data.Data;
          this.updateProcessDueDateWithFilterState.success = true;
        }
      })
      .catch((err: string) => {
        this.updateProcessDueDateWithFilterState.error = err;
      })
      .finally(
        action(() => {
          this.updateProcessDueDateWithFilterState.inProgress = false;
        })
      );
  };

  //#endregion

  //#region Computed
  get allActiveTrays(): any[] {
  // Return empty array if no tray data exists
  if (!this.activeTrayList?.Trays?.length) {
    return [];
  }

  return this.activeTrayList.Trays.map((tray) => {
    /**
     * Create a dynamic object where:
     * Key   = ProcessId
     * Value = DueDate information, "done", or "N/A"
     *
     * Example:
     * {
     *   1: "2026-06-17_1_2026-06-17",
     *   2: "done",
     *   3: "N/A"
     * }
     */
    const processDueDateMap = Object.fromEntries(
      tray.ActiveTrayProcessDue.map((process) => {
        const key = process.ProcessId;

        let value: string;

        if (process.IsComplete) {
          value = 'done';
        } else if (process.DueDate !== '0001-01-01') {
          value = `${process.DueDate}_${process.ProcessId}_${process.DueDate}`;
        } else {
          value = 'N/A';
        }

        return [key, value];
      })
    );

    /**
     * Transform tray data into grid-friendly format
     * and merge dynamic process columns.
     */
    return {
      TrayId: tray.TrayId,
      CustomerId: tray.CustomerId,
      Id: tray.Id,
      EndUserName: tray.EndUserName,
      EndUserOrderId: tray.EndUserOrderId,
      OrderId: tray.OrderId,
      SubContractor: tray.SubContractor,
      SubContractorName: tray.SubContractorName,
      ProductId: tray.ProductId,
      Katashiki1: tray.Katashiki1,
      Katashiki2: tray.Katashiki2,
      Kishu: tray.Kishu,
      ProcessName: tray.ProcessName,
      Quantity: tray.Quantity,
      InvoiceNumber: tray.InvoiceNumber,
      QuantityUnitName: tray.QuantityUnitName,

      // Display blank value when MissingParts is "-1"
      MissingParts: tray.MissingParts === '-1' ? ' ' : tray.MissingParts,

      // Ensure product comments always have a display value
      ProductComment1: tray.ProductComment1 || ' ',
      ProductComment2: tray.ProductComment2 || ' ',
      ProductComment3: tray.ProductComment3 || ' ',
      ProductComment4: tray.ProductComment4 || ' ',
      ProductComment5: tray.ProductComment5 || ' ',
      ProductComment6: tray.ProductComment6 || ' ',

      Remarks: tray.Remarks,
      isSelected: tray.isSelected,
      ProductName: tray.ProductName,
      Group: tray.Group,
      CurrentState: tray.CurrentState,

      // Format dates for display
      CustomerDueDate: fixTimezoneOffsetYYYYMMDD(
        tray.CustomerDueDate
      ),
      // PlanedDueDate: fixTimezoneOffset(
      //   tray.PlanedDueDate
      // ),

      // Placeholder array retained for compatibility
      ActiveTrayProcessDue: [],

      AbnormalityRemark: tray.AbnormalityRemark,

      // Add dynamic process columns
      ...processDueDateMap,
    };
  });
}

  // get allProcessHeaders(): IActiveTrayProcessDue[] {
  //   const processHeaders = new Map<string, IActiveTrayProcessDue>();
  //   if (this.activeTrayList?.Trays?.length > 0) {
  //     this.activeTrayList.Trays.forEach(({ ActiveTrayProcessDue }) => {
  //       ActiveTrayProcessDue.forEach((item) => {
  //         const processIdKey = item.ProcessId.toString(); // Convert number to string
  //         if (!processHeaders.has(processIdKey)) {
  //           processHeaders.set(processIdKey, item);
  //         }
  //       });
  //     });
  //   }
  //   return Array.from(processHeaders.values());
  // }

  get allProcessHeaders(): IActiveProcesses[] {
    const processHeaders: IActiveProcesses[] = [];
    if(this.activeTrayList?.Processes?.length > 0){
      this.activeTrayList.Processes.map((process) => {
        processHeaders.push({
          ProcessId: process.ProcessId,
          ProcessName: process.ProcessName,
          ProcessShortName: process.ProcessShortName,
          IsHidden: process?.IsHidden
        })
      })
    }
    return processHeaders;
  }

  get allProcessHeadersSequence(): string {
    if (this.activeTrayList?.Trays?.length > 0) {
      return this.activeTrayList.Trays[0].ActiveTrayProcessDue.filter(
        (item) => item.ProcessId >= 0
      )
        .map((item) => item.ProcessId.toString())
        .join(',');
    }
    return '';
  }

  get trayDetails(): ITrayVM {
    if (this.activeTray) {
      const {
        TrayId,
        CustomerId,
        Id,
        EndUserName,
        EndUserOrderId,
        OrderId,
        SubContractor,
        SubContractorName,
        ProductId,
        Katashiki1,
        Katashiki2,
        Kishu,
        ProcessName,
        Quantity,
        InvoiceNumber,
        QuantityUnitName,
        CustomerDueDate,
        MissingParts,
        PlanedDueDate,
        Group,
        ProductComment1,
        ProductComment2,
        ProductComment3,
        ProductComment4,
        ProductComment5,
        ProductComment6,
        CurrentState,
        Remarks,
        isSelected,
        ProductName,
      } = this.activeTray;
      return {
        TrayId,
        CustomerId,
        Id,
        EndUserName,
        EndUserOrderId,
        OrderId,
        SubContractor,
        SubContractorName,
        ProductId,
        Kishu,
        ProcessName,
        Quantity,
        InvoiceNumber,
        QuantityUnitName,
        MissingParts,
        Group,
        ProductComment1,
        ProductComment2,
        ProductComment3,
        ProductComment4,
        ProductComment5,
        ProductComment6,
        CurrentState,
        Remarks,
        isSelected,
        ProductName,
        CustomerDueDate: fixTimezoneOffset(CustomerDueDate),
        PlanedDueDate: fixTimezoneOffset(PlanedDueDate),
        // CustomerDueDate: convertNonUTCDateToLocalTimeZone(
        //   fixTimezoneOffset(CustomerDueDate)
        // ),
        // PlanedDueDate: convertNonUTCDateToLocalTimeZone(
        //   fixTimezoneOffset(PlanedDueDate)
        // ),
        Katashiki1,
        Katashiki2,
      };
    }
    return {
      Id: -1,
      ProductName: '',
      ...GetTrayState,
    };
  }

  get chartHeaders(): string[] {
    let headers = [];
    if (this.processWiseChartList && this.processWiseChartList.length > 0) {
      headers = this.processWiseChartList?.map((item) => {
        if (item.DueDate === '0001-01-01') {
          return 'Remaining';
        }

        return item.DueDate;
      });
    }
    return headers;
  }

  get chartData(): any[] {
    let data = [];
    if (this.processWiseChartList && this.processWiseChartList.length > 0) {
      data = this.processWiseChartList[0].ProcessChart.map((process) => {
        return {
          name: process.ProcessShortName,
          processName: process.ProcessName,
          values: this.processWiseChartList.map(
            (item) =>
              item.ProcessChart.find((p) => p.ProcessId === process.ProcessId)
                ?.Count || 0
          ),
        };
      });
    }
    return data;
  }

  get chartProcessMultiSelectOptions(): IMultiSelectOption[] {
    let processData: IMultiSelectOption[] = [];
    if (this.processWiseChartList && this.processWiseChartList.length > 0) {
      processData = this.processWiseChartList[0].ProcessChart.map((process) => {
        return {
          label: process.ProcessShortName,
          value: process.ProcessShortName,
        };
      });
    }
    return processData;
  }

  get allChartProcesses() {
    if (this.processWiseChartList && this.processWiseChartList.length > 0) {
      return this.processWiseChartList[0].ProcessChart.map((process) => ({
        label: process.ProcessShortName,
        value: process.ProcessId,
      }));
    }
    return [];
  }
  //#endregion

  //#region Reset
  reset = () => {
    this.activeTrayList = GetAllActiveTrayState;
  };

  resetTrayDetail = () => {
    this.activeTray = undefined;
    this.activeTrayState = { ...this.initialStateValue };
    this.duplicateData = '';
  };

  resetDeleteTray = () => {
    this.deleteTrayState = { ...this.initialStateValue };
  };

  resetAddUpdateTrayState = () => {
    this.addUpdateTrayState.inProgress = false;
    this.addUpdateTrayState.success = false;
    this.addUpdateTrayState.error = '';
  };

  resetFileUploadState = () => {
    this.fileUploadState.inProgress = false;
    this.fileUploadState.success = false;
    this.fileUploadState.error = '';
  };

  resetGetUpdateProcessDueDatetState = () => {
    this.getUpdateProcessDueDatetState = { ...this.initialStateValue };
  };

  resetSaveProcessOrderState = () => {
    this.saveProcessOrderState = {...this.initialStateValue};
  }

  resetUpdateProcessDueDateWithFilterState = () => {
    this.updateProcessDueDateWithFilterState = {...this.initialStateValue};
  }

  /**
   * This function is used to reset all store observables to their initial values.
   * @returns
   */
  resetStore = () => {
    this.activeTray = undefined;
    this.activeTrayState = { ...this.initialStateValue };
    this.activeTrayList = GetAllActiveTrayState;
    this.addUpdateTrayState = { ...this.initialStateValue };
    this.deleteTrayState = { ...this.initialStateValue };
    this.getActiveTrayListServiceState = { ...this.initialStateValue };
    this.fileUploadState = { ...this.initialStateValue };
    this.getProcessWiseChartListServiceState = { ...this.initialStateValue };
    this.processWiseChartList = [];
    this.getUpdateProcessDueDatetState = { ...this.initialStateValue };
    this.saveProcessOrderState = { ...this.initialStateValue };
    this.updateProcessDueDateWithFilterState = { ...this.initialStateValue };
    this.recordsUpdated = 0;
  };
  //#endregion
}

export default new ActiveTrayManagementStore();
